import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MarketingPageGetResponse } from './marketing_page_get';

@Injectable({ providedIn: 'root' })
export class MarketingAPI {
  constructor(private httpClient: HttpClient) {}

  private readonly _host: string = environment.api.marketing.host;
  private readonly _accessKey: string = environment.api.marketing.accessKey;

  async marketingPageGet(slug: string): Promise<MarketingPageGetResponse> {
    try {
      return await this.httpClient
        .get<MarketingPageGetResponse>(
          `${this._host}/v1/marketing-page/pages/${slug}`,
          {
            headers: new HttpHeaders().append('X-Api-Key', this._accessKey),
          }
        )
        .toPromise();
    } catch (err) {
      return {
        success: false,
        message: 'Something went wrong.',
      };
    }
  }
}
